import React, { FC } from 'react';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { HelpCircle } from 'lucide-react';
import s from './MobileCategoriesSelector.scss';
import { dataHooks } from '../datahooks';
import { dataHooks as categoryButtonDataHooks } from '../components/CategoryButton/datahooks';
import { Divider } from '../components/Divider/Divider';
import { CategoriesHeader } from './CategoriesHeader/CategoriesHeader';
import { DynamicSelector } from '../../../components/DynamicSelector/DynamicSelector';

interface MobileCategoriesSelectorProps {
  categories: [string, { name: string; Icon: any; color: string }][];
  selectedCategory: string | null;
  onCategorySelect: (category: string) => void;
}

export const MobileCategoriesSelector: FC<MobileCategoriesSelectorProps> = ({
  categories,
  selectedCategory,
  onCategorySelect,
}) => {
  const { t } = useTranslation();

  const options = categories.map(([key, { name, Icon, color }]) => ({
    value: key,
    label: (
      <Box align="center" gap={1}>
        <Icon size="16px" color={color} />
        <Text size="small">{t(name)}</Text>
      </Box>
    ),
  }));

  const handleSelect = (option: { value: string; label: string | React.ReactNode }) => {
    onCategorySelect(option.value);
  };

  const handleChooseForMe = () => {
    onCategorySelect('rts.chooseForMe');
  };

  return (
    <>
      <CategoriesHeader />

      <Box className={s.mobileCategoriesWrapper} gap={4} direction="vertical" width="100%">
        <DynamicSelector
          options={options}
          onSelect={handleSelect}
          selectedValue={selectedCategory}
          dataHook={dataHooks.CategorySelector}
          initialVisibleCount={options.length}
          className={s.categorySelector}
        />

        <Divider />

        <Box width="100%">
          <button
            onClick={handleChooseForMe}
            className={`${s.chooseForMeButton} ${selectedCategory === 'rts.chooseForMe' ? s.selected : ''}`}
            data-hook={categoryButtonDataHooks.categoryButton('rts.chooseForMe')}
          >
            <Box align="center" gap={2}>
              <HelpCircle size="16px" />
              <Text size="small">{t('DS_CATEGORY_CHOOSE_FOR_ME')}</Text>
            </Box>
          </button>
        </Box>
      </Box>
    </>
  );
};
